export default __webpack_public_path__ + "media/salad_banner.325c7189.png";